import React from 'react';

import { fontStyles } from '~src/theme/fontStyles';

export const Heading: React.FC<React.PropsWithChildren> = ({ children, ...props }) => {
  return (
    <div
      role="heading"
      aria-level={2}
      css={{
        fontVariationSettings: '"wght" 500',
        ...fontStyles.px16_20,
        marginBottom: '12px',
      }}
      {...props}
    >
      {children}
    </div>
  );
};
